export default {
  styleOverrides: {
    root: {},
    elevation1: {
      // boxShadow: 'unset',
    },
    elevation2: {
      boxShadow: 'unset',
    },
  },
};
